import React, { ReactNode } from "react";
import { animated, useSpring } from "react-spring";

import ProfileImage from "../ProfileImage";
import Ratio from "../Ratio";
import ordinal from "ordinal";

export interface AwardsItemProps {
  place?: number;
  header: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  institute: string;
  image?: string;
  src?: string;
}

const AwardsItem = ({
  place,
  header,
  title,
  subtitle,
  institute,
  image,
  src,
}: AwardsItemProps) => {
  // Animation
  const animation = useSpring({
    opacity: "1",
    transform: "translateY(0px)",
    from: {
      opacity: "0",
      transform: "translateY(10px)",
    },
  });

  if (src) {
    return (
      <Ratio w={3} h={2}>
        <div className="flex items-center justify-center w-full h-full">
          <video
            className="w-full px-8"
            src={src}
            preload="auto"
            controls={true}
            autoPlay={true}
          ></video>
        </div>
      </Ratio>
    );
  }

  return (
    <animated.div
      className="flex flex-wrap items-center p-4 space-y-8 bg-gray-100 lg:space-y-0 lg:space-x-8 lg:flex-no-wrap"
      style={animation}
    >
      <div className="w-2/12 lg:w-2/12">
        {place ? (
          <Ratio>
            <div className="flex items-center justify-center w-full h-full bg-gray-200 rounded-full">
              <div className="text-2xl font-bold">{ordinal(place)}</div>
            </div>
          </Ratio>
        ) : (
          <ProfileImage src={image} />
        )}
      </div>
      <div className="w-full lg:w-6/12">
        <div className="space-y-4">
          <div className="text-lg font-medium">{header}</div>
          <div className="space-y-2">
            <div className="text-xl text-cream">{title}</div>
            <div className="text-sm text-gray-400">{subtitle}</div>
          </div>
        </div>
      </div>
      <div className="w-full lg:w-2/12">
        <div className="space-y-4">
          <div className="text-lg font-medium text-gray-300">Institute</div>
          <div className="text-gray-400">{institute}</div>
        </div>
      </div>
    </animated.div>
  );
};

export default AwardsItem;
